import LegalLayout, { Section, Bullets } from "@/components/LegalLayout";
import { PLACEHOLDERS } from "@/constants/legalContent";
import { PhiWarning } from "@/components/Notices";

export default function Contact() {
  return (
    <LegalLayout
      title="Contact FindRxStaff"
      intro="Questions about the platform, a report you filed, your account, or our legal documents? Here is how to reach us."
    >
      <Section heading="General and account support">
        <p>Email: {PLACEHOLDERS.email}</p>
        <p>
          Please include your account email and a short description of the issue. Do not include patient
          information, PHI, prescriptions, passwords or financial account details in any message to us.
        </p>
        <PhiWarning testId="contact-phi-warning" />
      </Section>

      <Section heading="Legal and privacy enquiries">
        <Bullets items={[`Legal entity: ${PLACEHOLDERS.entity}`, `Legal contact: ${PLACEHOLDERS.email}`]} />
        <p>
          For legal or privacy enquiries, email {PLACEHOLDERS.email} with a short description and we will
          route it to the right person.
        </p>
      </Section>

      <Section heading="Reporting prohibited content">
        <p>
          The fastest route is the Report action on the relevant worker profile, pharmacy profile or shift
          inside the app — those reports go straight to our review queue. For urgent concerns involving
          patient information or PHI, also email {PLACEHOLDERS.email} with the report reference.
        </p>
      </Section>

      <Section heading="What FindRxStaff cannot help with">
        <p>
          FindRxStaff does not provide legal, employment, tax or professional advice, does not process
          payments, and is not a party to agreements between users. Pay, schedule and workplace questions
          should be settled directly between the pharmacy and the worker.
        </p>
      </Section>
    </LegalLayout>
  );
}
